var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7C6.25 4.65279 8.15279 2.75 10.5 2.75C12.8472 2.75 14.75 4.65279 14.75 7C14.75 7.41421 15.0858 7.75 15.5 7.75C15.9142 7.75 16.25 7.41421 16.25 7C16.25 3.82436 13.6756 1.25 10.5 1.25C7.32436 1.25 4.75 3.82436 4.75 7C4.75 7.41421 5.08579 7.75 5.5 7.75C5.91421 7.75 6.25 7.41421 6.25 7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4636 6.90257V11.353L15.0252 12.1193C17.0677 12.7304 18.089 13.0359 18.624 13.9C19.1591 14.7641 19.0359 15.9086 18.7893 18.1977L18.7003 19.0238C18.4965 20.916 18.3946 21.8621 17.8068 22.431C17.219 23 16.3436 23 14.5926 23H11.1846C10.0988 23 9.55587 23 9.09802 22.7328C8.64015 22.4656 8.33982 21.9735 7.73916 20.9894L4.17933 15.1568C3.94617 14.7748 3.93989 14.2797 4.16328 13.8908C4.90388 12.6016 6.56076 12.4125 7.53106 13.5066L8.9663 15.1249V6.90257C8.9663 5.85178 9.74923 4.99997 10.715 5C11.6807 5.00003 12.4636 5.85183 12.4636 6.90257Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTap);
export default __webpack_public_path__ + "static/media/tap.ae752436689a383a7e1292a81674a5d3.svg";
export { ForwardRef as ReactComponent };